<template>
  <vue-modal id="changeEmailModal"
             classes="vue-modal-container"
             height="auto"
             name="change-email-modal"
             width="300px">
    <div class="header">
      <h3>{{ trans.header }}</h3>
      <button class="close-modal"
              @click="$modal.hide('change-email-modal')">
        <i class="close icon"/>
      </button>
    </div>
    <div class="content">
      <div class="ui form">
        <div class="field">
          <label>{{ trans.newMainAddress }}
            <input v-model="newEmail"
                   :placeholder="trans.newMainPlaceholder"
                   type="email"
                   @keyup.enter="changeEmail">
          </label>
        </div>
      </div>
    </div>
    <div class="actions">
      <button class="ui positive button"
              @click="changeEmail">{{ trans.changeEmailBtnText }}
      </button>
    </div>
  </vue-modal>
</template>

<script>
import utils from '@/utils'
import notify from '@/notify'
import {mapState} from 'vuex'

export default {
  data () {
    return {
      newEmail: '',
    }
  },
  methods: {
    changeEmail () {
      let newEmail = this.newEmail
      if (utils.isEmailValid(newEmail)) {
        this.$parent.$emit('changeEmail', newEmail)
      } else {
        notify.warning('Csak helyes email címet adhat meg')
      }
    },
  },
  computed: {
    ...mapState({
      trans: state => state.trans.changeEmailModal,
    }),
  },
}
</script>

<style scoped>

</style>
